import React, {FC} from 'react'
import { Menu } from 'semantic-ui-react'
import { translate } from 'loankeeper-common/helpers'
import { LKIcon } from 'loankeeper-common/components'
import { LKDate } from 'loankeeper-common/helpers/Date'
//@ts-ignore
import LKGrid from 'shared/LKGrid'

import { constants as DCConstants } from '../../../DetailsContainer'

import { ClientDetailsHistoryProps } from '../../types'

const LKGridConfig = {
  gridIdentity: {
    formName: 'frm_client_key_details_history',
    objectName: 'dbgrd_history',
  },
  columnConfigs: {
    ChangeDate: { valueFormatter: ({ value }) => LKDate.from(value).toTString() },
  },
  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,
}

const ClientDetailsHistory: FC<ClientDetailsHistoryProps> = ({ data, ID }) => (
  <>
    <Menu attached="top">
      <Menu.Item className="u-noPadding u-paddingRight-15 u-paddingLeft-5">
        <LKIcon alias="footprint" style={{ marginRight: 5 }} />

        {translate('frm_client_key_details_history-frm_client_key_details_history')}
      </Menu.Item>
    </Menu>

    {/* @ts-ignore */}
    <div className="u-fluid u-relative" attached="bottom">
      <LKGrid
        instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-DetailsHistory`}
        rowData={data}
        {...LKGridConfig}
      />
    </div>
  </>
)

ClientDetailsHistory.defaultProps = {
  data: [],
}

export default ClientDetailsHistory
